import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, TextInput, SelectInput } from "@/components/FormKit";
import { activitiesApi, apiErrorMessage } from "@/api/client";
import { toast } from "sonner";

const TYPES = ["note", "phone_call", "email", "meeting", "demo"];
const labelize = (s) => s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export function NoteDialog({ open, onOpenChange, orgId, onSaved }) {
  const [form, setForm] = useState({ activity_type: "note", summary: "", content: "" });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) { setForm({ activity_type: "note", summary: "", content: "" }); setError(""); } }, [open]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.summary.trim()) { setError("Summary is required"); return; }
    setSaving(true); setError("");
    try {
      const res = await activitiesApi.create(orgId, { activity_type: form.activity_type, summary: form.summary, content: form.content || null });
      toast.success("Activity logged");
      onSaved?.(res.data);
      onOpenChange(false);
    } catch (err) { setError(apiErrorMessage(err)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="note-dialog">
        <DialogHeader><DialogTitle className="font-heading">Add note / activity</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Type">
            <SelectInput testid="note-type" value={form.activity_type} onChange={set("activity_type")}>
              {TYPES.map((t) => <option key={t} value={t}>{labelize(t)}</option>)}
            </SelectInput>
          </Field>
          <Field label="Summary"><TextInput testid="note-summary" value={form.summary} onChange={set("summary")} placeholder="Short summary" /></Field>
          <Field label="Detail (optional)"><TextInput testid="note-content" value={form.content} onChange={set("content")} /></Field>
          {error && <p data-testid="note-error" className="text-sm font-medium text-rose-600">{error}</p>}
          <button type="submit" disabled={saving} data-testid="note-submit"
            className="min-h-[48px] w-full rounded-lg bg-teal-700 font-semibold text-white hover:bg-teal-800 disabled:opacity-60">
            {saving ? "Saving…" : "Log activity"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
